import { trackOneTagBookCreation } from './oneTag'

const DEFAULT_WEB_APP_ORIGIN = 'https://app.storytailor.co.kr'
const LOCAL_WEB_APP_PORT = '3000'

/** 기능 앱 로그인 경로 */
export const WEB_APP_LOGIN_PATH = '/login'

/** 기능 앱 동화책 갤러리 경로 */
export const WEB_APP_GALLERY_PATH = '/gallery'

/**
 * 로컬 개발: 랜딩(:3001)에서 기능 웹앱(:3000)으로 CTA·로그인 링크를 보낼 때 사용.
 * `REACT_APP_WEB_APP_ORIGIN`이 비었을 때 localhost/127.0.0.1 + 3000 포트를 추론한다.
 */
function inferLocalDevWebAppOrigin(): string {
  if (typeof window === 'undefined') return ''
  if (process.env.NODE_ENV === 'production') return ''
  const h = window.location.hostname
  if (h !== 'localhost' && h !== '127.0.0.1') return ''
  const proto = window.location.protocol || 'http:'
  return `${proto}//${h}:${LOCAL_WEB_APP_PORT}`
}

/**
 * 기능 앱(app.storytailor.co.kr)으로 보낼 절대 URL.
 * REACT_APP_WEB_APP_ORIGIN 은 슬래시 없이 (예: https://app.storytailor.co.kr).
 */
export function getWebAppOrigin(): string {
  const raw = (process.env.REACT_APP_WEB_APP_ORIGIN || '').trim().replace(/\/$/, '')
  if (raw) return raw
  const local = inferLocalDevWebAppOrigin()
  if (local) return local
  return DEFAULT_WEB_APP_ORIGIN
}

export function webAppLoginUrl(): string {
  return webAppUrl(WEB_APP_LOGIN_PATH)
}

export function webAppGalleryUrl(): string {
  return webAppUrl(WEB_APP_GALLERY_PATH)
}

export function webAppUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${getWebAppOrigin()}${p}`
}

export function goWebApp(path: string): void {
  const normalized = path.startsWith('/') ? path : `/${path}`
  if (
    normalized === '/book-creation' ||
    normalized.startsWith('/book-creation?')
  ) {
    trackOneTagBookCreation()
  }
  window.location.assign(webAppUrl(path))
}
